import LinkedinIcon from "@mitch528/mdi-material-ui/Linkedin";
import { Box, Container, Grid, Typography } from "@mui/material";
import React from "react";
import { colors } from "./theme";

export function Footer() {
    return (
        <Box
            sx={{
                backgroundColor: colors.background,
                color: "rgba(255, 255, 255, 0.7)",
                mt: 8,
                pb: {
                    xs: 6,
                    sm: 3,
                },
                pt: {
                    xs: 6,
                    sm: 3,
                },
                "& ul": {
                    margin: 0,
                    padding: 0,
                    listStyle: "none",
                },
                "& li": {
                    paddingTop: 0.3,
                    paddingBottom: 0.3,
                    paddingLeft: 0,
                    paddingRight: 0,
                },
            }}
        >
            <Container maxWidth="md">
                <Grid
                    container
                    justifyContent="space-between"
                    alignItems="center"
                >
                    <Grid item>
                        <a
                            href="https://www.linkedin.com/company/qped"
                            target="_blank"
                            style={{
                                marginLeft: -5,
                                color: "rgba(255, 255, 255, 0.7)",
                            }}
                        >
                            <LinkedinIcon fontSize="large" />
                        </a>
                    </Grid>
                    <Grid item>
                        <Typography
                            variant="body2"
                            color="inherit"
                            align="center"
                        >
                            {`Copyright © QPED ${new Date().getFullYear()}.`}
                        </Typography>
                    </Grid>
                </Grid>
            </Container>
        </Box>
    );
}
